// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32CFH","badges":"styles_badges__nHl3F"};